import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react";
import { toast, Toaster as Sonner } from "sonner";
import { useTheme } from "@/lib/theme";
import { Spinner } from "./spinner";

export { toast };

/** App-wide toaster (sonner), themed with brand tokens; announced via aria-live by sonner. */
export function Toaster() {
  const { resolvedTheme } = useTheme();
  return (
    <Sonner
      theme={resolvedTheme}
      position="bottom-right"
      closeButton
      visibleToasts={4}
      gap={10}
      offset={20}
      mobileOffset={12}
      containerAriaLabel="Notifications"
      icons={{
        success: <CircleCheck className="size-[18px] text-success" />,
        error: <CircleAlert className="size-[18px] text-danger" />,
        warning: <TriangleAlert className="size-[18px] text-warning" />,
        info: <Info className="size-[18px] text-info" />,
        loading: <Spinner className="text-primary" />,
      }}
      toastOptions={{
        classNames: {
          toast: "l2a-toast",
          actionButton: "!rounded-pill !bg-ink !px-3 !font-bold !text-ink-fg hover:!bg-ink-hover",
          cancelButton: "!rounded-pill !font-bold",
          closeButton: "!border-line !bg-surface-raised !text-fg-muted",
        },
      }}
    />
  );
}

/**
 * Toast with Undo for reversible actions (archive, remove from list, status change).
 * Apply the change optimistically, then:
 *   toastUndo("Invoice archived", { onUndo: () => restore.mutate(id) });
 */
export function toastUndo(message: string, opts: { onUndo: () => void; description?: string; duration?: number }) {
  return toast.success(message, {
    description: opts.description,
    duration: opts.duration ?? 7000,
    action: { label: "Undo", onClick: opts.onUndo },
  });
}
